import {
    FILE_ICON_PDF,
    FILE_ICON_DOC,
    FILE_ICON_XLS,
    FILE_ICON_CSV,
    FILE_ICON_PPT,
    FILE_ICON_TEXT,
} from '../../../../../../../../assets/hostedassets';

/** Maps a file extension (lower-cased) to its display icon for FileAttachmentCard. */
export const FILE_TYPE_ICONS: Record<string, string> = {
    pdf: FILE_ICON_PDF,
    doc: FILE_ICON_DOC,
    docx: FILE_ICON_DOC,
    xls: FILE_ICON_XLS,
    xlsx: FILE_ICON_XLS,
    csv: FILE_ICON_CSV,
    ppt: FILE_ICON_PPT,
    pptx: FILE_ICON_PPT,
    txt: FILE_ICON_TEXT,
    text: FILE_ICON_TEXT,
};

/** Fallback icon when the extension has no specific mapping. */
export const DEFAULT_FILE_ICON = FILE_ICON_DOC;
